import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type { PolicyAction } from '../../../../shared/model-typings';
import type { Policy } from '../../../types';

import { getQueryKeyForPolicy } from './useFetchPolicy';

type PolicyUpdate = Partial<Policy> & {
  defaultAction?: PolicyAction;
  onlyConcludedLicensesEnabled?: boolean;
  intelligentAutoIgnoreEnabled?: boolean;
  unconcludedIssueScanningEnabled?: boolean;
};

const putPolicy = (policyId: number, policy: PolicyUpdate) => {
  return put<PolicyUpdate, Policy>(`/api/policies/${policyId}`, policy);
};

/**
 * hook for updating one policy
 */
export default function useUpdatePolicy(policyId: number, onSuccessCallback: () => void) {
  return useToastedMutation({
    mutationFn: (policy: PolicyUpdate) => putPolicy(policyId, policy),
    successToastMessage: 'Policy updated successfully.',
    errorToastMessage: 'Failed to update policy.',
    onSuccess: () => {
      onSuccessCallback();
      queryClient.invalidateQueries({ queryKey: getQueryKeyForPolicy(policyId) });
    },
  });
}
